import React, { useEffect, useState } from 'react';
import {
  Routes,
  Route,
  Link,
  useParams,
} from 'react-router-dom';
import Loader from './Loader';
import ArticleFull from './ArticleFull';
import './Results.css';
import { useTranslation } from './Translator';

const getData = async (relative_path, query_params) => {
  const hasQuery = query_params ? '?' + query_params : '';
  const endpoint = process.env.REACT_APP_FEED_URL;
  const generated_URL = endpoint + relative_path + hasQuery;
  try {
    const res = await fetch(generated_URL, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    });
    return await res.json();
  } catch (error) {
    console.error(error);
  }
};

// Helper function to find the featured image.
const findFeaturedImage = (article) => {
  if (Array.isArray(article.field_image) && article.field_image.length > 0) {
    return article.field_image[0].url;
  }
  return '';
};

const Results = () => {
  // article listing state.
  const [articleList, setArticleList] = useState([]);

  // Get the correct path for the backend.
  const path = '/frontpage';

  useEffect(() => {
    // adding intentional delay for UI.
    setTimeout(() => {
      getData(path)
        .then(res => {
          setArticleList(res);
        })
        .catch((error) => {console.log(error);});
    }, 1000);
  }, [path]);

  // Component for a single article card in the listing
  const ArticleItem = ({ curr }) => {
    const { translate } = useTranslation();
    const title = curr.title[0].value;
    const summary = curr.body[0].summary;
    const id = curr.nid[0].value;
    const path = curr.path[0].alias;
    const featuredImage = findFeaturedImage(curr);

    const [displayTitle, setDisplayTitle] = useState(title);
    const [displaySummary, setDisplaySummary] = useState(summary);

    useEffect(() => {
      translate(title).then(setDisplayTitle);
      translate(summary).then(setDisplaySummary);
    }, [title, summary, translate]);

    return (
      <div className="article" key={id}>
        <Link to={path}>
          {featuredImage ? <div className="featured-image-wrapper"><img
            className="featured-image" src={featuredImage} alt={displayTitle}/>
          </div> : null}
          <div className="title">{displayTitle}</div>
        </Link>
        <div className="article-snippet"
             dangerouslySetInnerHTML={{ __html: displaySummary }}/>
        <hr/>
      </div>
    );
  };

  // Component for the list of all articles
  const ArticleList = () => (
    <div className="article-lists">
      {articleList.map((curr) => (
        <ArticleItem key={curr.nid[0].value} curr={curr} />
      ))}
    </div>
  );

  // Component for individual article — ArticleFull handles its own translation
  const SingleArticle = () => {
    const { path } = useParams();
    const needle = `/content/${path}`;
    const article = articleList.find(art => art.path[0].alias === needle);

    if (!article) {
      return <div>Article not found</div>;
    }

    return (
      <ArticleFull
        title={article.title[0].value}
        body={article.body[0].processed}
        id={article.nid[0].value}
        date={article.changed[0].value}
        featuredImage={findFeaturedImage(article)}
      />
    );
  };

  return (
    <div className="results-wrapper">
      {articleList?.length === 0 ? (
        <Loader key="unique-loader"/>
      ) : (
        <Routes>
          <Route path="/content/:path/*" element={<SingleArticle/>}/>
          <Route path="/" element={<ArticleList/>}/>
        </Routes>
      )}
    </div>
  );
};
export default Results;
